import type { OnDestroy, OnInit } from '@angular/core';
import {
  Directive,
  inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { getIsExperienceEditorClientActive } from '@core/jss-routing';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[wlShowInLive]',
  standalone: true,
})
export class ShowInLiveDirective implements OnInit, OnDestroy {
  private readonly ngUnsubscribe$ = new Subject();
  private readonly store$ = inject(Store);
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);

  private readonly experienceEditorInactive$ = this.store$.pipe(
    select(getIsExperienceEditorClientActive),
    map((active) => !active),
    takeUntil(this.ngUnsubscribe$)
  );

  ngOnInit() {
    this.experienceEditorInactive$.subscribe((inactive) => {
      if (inactive) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }
}
